import PropTypes from 'prop-types';
import React from 'react';

import './styles/headingContentStyles.css';

// Header
// NOTE: Only two root children are permitted and will be displayed.
//		 This component uses the concept of "named slots".
//		 On the root tag of each child add "slot=" with a value of the slot,
//		 either "start-content" or "end-content".
const Header = ({ children }) => {
  const slots = {};
  React.Children.forEach(children, (child) => {
    slots[child.props.slot] = React.cloneElement(child, {});
  });

  const startContent = slots['start-content'];
  const endContent = slots['end-content'];

  return (
    <div className="flex flex-row items-start justify-between heading-content-margin">
      {startContent}
      {endContent}
    </div>
  );
};

Header.defaultProps = {};

Header.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Header;
